import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalHeartbeatsRoute: InvariantJiraRoute = {
	name: 'eoc-global-heartbeats',
	path: '/jira/settings/products/ops/heartbeats',
	exact: true,
};
